import React from 'react';
import { Advisor } from 'src/models';
import css from './CalendarSelectAdv.module.scss';
import classNames from 'classnames';
import { Button, Avatar } from '@framework-controls/core';
import { strings } from 'src/localization';
import NoProfile from 'src/content/icons/Profile2.svg';
import NoProfileWhite from 'src/content/icons/ProfileWhite.svg';
import { IconProfile2 } from 'src/content/icons';

interface IProps {
    id: string;
    advisor: Advisor;
    onSelect: (advisor: Advisor, event: any) => void;
    selected: boolean;
    theme: string;
}

const CalendarSelectAdvPanel = (props: IProps) => {
    const { advisorName, advisorImage } = props.advisor;

    const onClick = (event: any, advisor: Advisor) => {
        props.onSelect(advisor, event);
    };

    const btnClassName = classNames(
        css.advBtn,
        {
            [css.advBtnChecked]: props.selected,
            [css.advBtnCS]: props.theme === 'colorSensitive',
            [css.advBtnCA]: props.theme === 'cadillac',
            [css.advBtnHyundai]: props.theme === 'hyundai',
            [css.advBtnCV]: props.theme === 'chevrolet' || props.theme === 'mercedesBenz',
            [css.advBtnHonda]: props.theme === 'honda',
            [css.advBtnBuick]: props.theme === 'buick',
            [css.advBtnBMW]: props.theme === 'bmw',
            [css.advBtnFord]: props.theme === 'ford',
            [css.advBtnIN]: props.theme === 'infiniti',
            [css.advBtnNissan]: props.theme === 'nissan',
            [css.advBtnMazda]: props.theme === 'mazda',
            [css.advBtnAcura]: props.theme === 'acura',
        },
    );

    const AdvImgAltTag = advisorName + ' ' + strings.Photo;
    let image = advisorImage;
    switch (image){
        case '':
        case undefined:
            image = NoProfile;
            break;
        default:
            break;
    }

    let tooltip = strings.ChooseAdvisorTip;
    if (props.id === 'noPrefBtn') {
        tooltip = strings.NoAdvisorTip;
        image = NoProfile;
    }

    let avatarColor: 'default' | 'primary' | 'secondary' | 'contrast' | 'completed' | 'blank' = 'blank';
    if (props.theme === 'toyotaSPM' || props.theme === 'infiniti') {
        avatarColor = 'contrast';
    }
    if (!props.selected && props.theme === 'toyotaSPM') {
        avatarColor = 'contrast';
    }
    if (!advisorImage){
        if (props.selected && props.theme === 'toyotaSPM') {
            avatarColor = 'primary';
            image= NoProfileWhite;
        }
    }

    let avatar = <Avatar
        elevation={0}
        size={60}
        color={avatarColor}
        borderThickness={0}
        src={image}
        alt={AdvImgAltTag}
    />;

    if (props.theme === 'colorSensitive') {
        image= NoProfileWhite;
        avatar = <Avatar
            elevation={0}
            size={60}
            color='primary'
            borderThickness={0}
            src={image}
            alt={AdvImgAltTag}
        />;
    }

    if (props.theme === 'hyundai' && (image === NoProfile || image === NoProfileWhite)) {
        const avatarHyundaiClass = props.selected ? css.avatarSelectedHyundai : css.avatarHyundai;
        avatar = <IconProfile2 className={avatarHyundaiClass} />;
    }

    return (
        <div className={btnClassName}>
            <Button
                key={props.advisor.advisorNum}
                id='advisorBtn'
                onClick={(event) => onClick(event, props.advisor)}
                type='custom'
                variant={props.selected ? 'advBtnChecked' : 'advBtn'}
                tooltip={tooltip}
            >
                <div className={css.btnArea}>
                    <div className={css.advBtnContents}>
                        {avatar}
                    </div>
                    <div className={css.advBtnContents}>{advisorName}</div>
                </div>
            </Button>
        </div>
    );
};

export default CalendarSelectAdvPanel;